import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseApiTemplateService} from '../../shared';
import {Core2Config} from '../../shared';
import {
  ClaimEntitlementAutoTopUpEventJobRoleFilterContainerModel
} from '../../../../../../models';


@Injectable({
  providedIn: 'root'
})
export class ClaimEntitlementAutoTopUpEventJobRoleFilterService extends BaseApiTemplateService<ClaimEntitlementAutoTopUpEventJobRoleFilterContainerModel> {
  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX +
    Core2Config.AAT_PREFIX + Core2Config.CLAIMS_PREFIX + 'accounts/entitlements/auto-top-up-events/filter-job-roles/backoffice-ep';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX +
      Core2Config.AAT_PREFIX + Core2Config.CLAIMS_PREFIX + 'accounts/entitlements/auto-top-up-events/filter-job-roles/backoffice-ep';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.AAT_PREFIX +
      Core2Config.CLAIMS_PREFIX + 'accounts/entitlements/auto-top-up-events/filter-job-roles/backoffice-ep';
    this.httpClient = http;
  }
}


